import { useMemo } from 'react';

/**
 * Custom hook to determine if the current pathname indicates an onboarding path.
 *
 * @returns boolean indicating if the current pathname is an onboarding path
 * ```
 */
const ONBOARDING_PATH_REGEX = /^\/?onboarding/;

export function useIsOnboardingPath(): boolean {
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';
  return useMemo(() => {
    return !!pathname.match(ONBOARDING_PATH_REGEX);
  }, [pathname]);
}
